// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { appcast as baseAppcastTheme } from "@stepstone-genesis/design-tokens";
var appcast = extendBaseTheme("appcast", baseAppcastTheme);
export {
  appcast
};
